import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { UserAuthEntity } from 'user-identity-js/lib/entities/user.entity';
import { USER } from '../../constants';
interface AuthState {
	account: UserAuthEntity | null;
}

const initialState = {
	account: null,
} as AuthState;

const authSlice = createSlice({
	name: 'authSlice',
	initialState,
	reducers: {
		setAccount: (state, action: PayloadAction<UserAuthEntity>) => {
			state.account = action.payload;
		},
		logout: (state) => {
			state.account = null;
			localStorage.removeItem(USER);
		},
	},
});

export const { setAccount, logout } = authSlice.actions;
export default authSlice.reducer;
